import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

export function Vision() {
  const ref = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [60, -60]);
  const opacity = useTransform(scrollYProgress, [0, 0.3, 0.7, 1], [0.3, 1, 1, 0.3]);

  return (
    <section id="vision" ref={ref} className="relative overflow-hidden py-44">
      <motion.div
        style={{ y }}
        className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_50%,oklch(0.35_0.22_250/0.25),transparent_60%)]"
      />
      <motion.div
        style={{ y: useTransform(scrollYProgress, [0, 1], [-30, 30]) }}
        className="absolute inset-0 bg-[radial-gradient(ellipse_at_80%_30%,oklch(0.30_0.18_280/0.20),transparent_55%)]"
      />
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />

      <motion.div style={{ opacity }} className="relative mx-auto max-w-5xl px-6 text-center">
        <div className="mb-6 text-[11px] uppercase tracking-[0.3em] text-electric">Vision</div>
        <h2 className="text-gradient text-[clamp(2.25rem,5.5vw,4.75rem)] font-semibold leading-[1.05] tracking-[-0.035em]">
          The Goal Is Not To Follow Technology.
          <br />
          The Goal Is To{" "}
          <span className="text-electric-gradient italic font-medium">Build With It.</span>
        </h2>
        <p className="mx-auto mt-10 max-w-2xl text-lg text-muted-foreground">
          Artificial Intelligence is transforming every industry. I am exploring how software,
          automation, and AI can combine to create scalable products that impact millions of
          people.
        </p>
        <p className="mt-6 text-sm uppercase tracking-[0.25em] text-muted-foreground">
          This is only the first chapter.
        </p>
      </motion.div>
    </section>
  );
}
